import messages from '../locales/messages';
import './InstanaPriceEstimator.scss';
import { roiCookieContent } from './InstanaPriceEstimator';
import { ReactElement, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import 'src/common/style/common.scss';
import { ThanksModal, thanksTable } from 'src/common/utils/ThanksModal';

export interface thanksProps {
  iqmHosts: number;
  apmHosts: number;
  productToAcquire: string;
  estimatedPrice: string;
  cookieContent: roiCookieContent;
  bpName: string;
  bpConsentMail: boolean;
}

const Thanks = ({
  iqmHosts,
  apmHosts,
  productToAcquire,
  estimatedPrice,
}: thanksProps): ReactElement => {
  const intl = useIntl();
  const [showThanksModal, setShowThanksModal] = useState(true);
  const titleThanks: thanksTable[] = [
    {
      group: 'title',
      value: String(intl.formatMessage(messages['thankYouTitle'])),
    },
    {
      group: 'subTitle',
      value: String(intl.formatMessage(messages['thankYouSubTitle'])),
    },
  ];
  const widgetTitleThanks: thanksTable[] = [
    {
      group: 'widgetTitle1',
      value: String(intl.formatMessage(messages['thankYouDetailsTitle'])),
    },
  ];
  const contentThanks: thanksTable[] = [
    {
      group: String(intl.formatMessage(messages['numberOfAPMHostsLabelTitle'])),
      value: String(apmHosts),
    },
    {
      group: String(intl.formatMessage(messages['numberOfIQMHostsLabelTitle'])),
      value: String(iqmHosts),
    },
    {
      group: String(intl.formatMessage(messages['productToAcquire'])),
      value: String(productToAcquire),
    },
    {
      group: String(intl.formatMessage(messages['estimatedCosts'])),
      value: String(estimatedPrice),
    },
  ];
  const buttonThanks: thanksTable[] = [
    {
      group: 'button1',
      value: String(intl.formatMessage(messages['returnToEstimator'])),
    },
  ];
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    setShowModal(true);
  }, [apmHosts, iqmHosts, productToAcquire]);
  return (
    <ThanksModal
      showThanksModal={showModal}
      pageTitle="Instana Price Estimator Page"
      object="Instana Pricing Page"
      productTitle={'Instana PE'}
      pageUrl={''}
      location={'Estimator'}
      titleThanks={titleThanks}
      widgetTitleThanks={widgetTitleThanks}
      contentThanks={contentThanks}
      buttonThanks={buttonThanks}
      setShowThanksModal={setShowThanksModal}
    ></ThanksModal>
  );
};

export default Thanks;
